export class Tutor {
  id:number;
  name:string;
  image:string;
  description:string;
  qualifications:string;
  websiteUrl:string;

  constructor(tutor?){
    if(tutor){
      this.id=tutor.id;
      this.name=tutor.name;
      this.image=tutor.image;
      this.description=tutor.description;
      this.qualifications=tutor.qualifications;
      this.websiteUrl=tutor.website_url;
    }
  }
}
